// @flow

// Utils
import createReducer from 'fc-utils/createReducer'

// InitialState
import {
  default as initialState,
  operatorInitialState,
} from './initialState'

// Operator
import {
  reducers as operatorReducers,
} from 'hfty-operator-fertilizers'

// Controller
import fertilizerController from 'fc-ctrl-fertilizers'

// Exports
export default createReducer({
  ...initialState,
}, {
  ...fertilizerController.reducers,
})

export const operationsReducers = createReducer({
  ...operatorInitialState,
}, {
  ...operatorReducers,
})
